import { render, staticRenderFns } from "./BrowserInformationViewer.vue?vue&type=template&id=9fbff2b4&scoped=true&"
import script from "./BrowserInformationViewer.vue?vue&type=script&lang=ts&"
export * from "./BrowserInformationViewer.vue?vue&type=script&lang=ts&"
import style0 from "./BrowserInformationViewer.vue?vue&type=style&index=0&id=9fbff2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbff2b4",
  null
  
)

export default component.exports